import { GlLink, GlIcon, GlAvatarsInline, GlTooltipDirective, GlDisclosureDropdown, GlDisclosureDropdownItem, GlBadge } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import ItemMilestone from '/builds/gitlab/gitlab-ee/app/assets/javascripts/issuable/components/issue_milestone.vue?vue3';
import TooltipOnTruncate from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/directives/tooltip_on_truncate.js?vue3';
import CiIcon from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/ci_icon/ci_icon.vue?vue3';
import UserLinkWithTooltip from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/user_link_with_tooltip.vue?vue3';
import { __, s__, sprintf } from '~/locale';
import toast from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/plugins/global_toast.js?vue3';
import { STATUS_CLOSED, STATUS_MERGED } from '~/issues/constants';
import { localeDateFormat, newDate } from '~/lib/utils/datetime_utility';
export default {
    name: 'WorkItemDevelopmentMrItem',
    components: {
        GlLink,
        GlIcon,
        GlAvatarsInline,
        ItemMilestone,
        CiIcon,
        UserLinkWithTooltip,
        GlDisclosureDropdown,
        GlDisclosureDropdownItem,
        GlBadge
    },
    directives: {
        GlTooltip: GlTooltipDirective,
        TooltipOnTruncate
    },
    props: {
        itemContent: {
            type: Object,
            required: true
        },
        workItemFullPath: {
            type: String,
            required: true
        }
    },
    computed: {
        assignees () {
            return this.itemContent?.assignees?.nodes || [];
        },
        badgeVariant () {
            return {
                [STATUS_CLOSED]: 'danger',
                [STATUS_MERGED]: 'info'
            };
        },
        badgeLabel () {
            return {
                [STATUS_CLOSED]: s__('WorkItem|Closed'),
                [STATUS_MERGED]: s__('WorkItem|Merged')
            };
        },
        stateBadgeLabel () {
            return this.badgeLabel[this.itemContent.state];
        },
        stateBadgeVariant () {
            return this.badgeVariant[this.itemContent.state];
        },
        assigneesCollapsedTooltip () {
            if (this.assignees.length > 2) {
                return sprintf(s__('WorkItem|%{count} more assignees'), {
                    count: this.assignees.length - 2
                });
            }
            return '';
        },
        showPath () {
            return this.itemContent.project.fullPath !== this.workItemFullPath;
        },
        fullReferenceWithPath () {
            return `${this.itemContent.project.fullPath}${this.itemContent?.reference}`;
        },
        detailedStatus () {
            return this.itemContent?.headPipeline?.detailedStatus;
        },
        milestone () {
            return this.itemContent?.milestone;
        },
        branchName () {
            return this.itemContent?.sourceBranch;
        },
        isMRClosed () {
            return this.itemContent.state === STATUS_CLOSED;
        },
        isMRMerged () {
            return this.itemContent.state === STATUS_MERGED;
        },
        isMergedOrClosed () {
            return this.isMRClosed || this.isMRMerged;
        },
        iconTooltip () {
            return __('Merge request');
        },
        badgeTooltip () {
            const tooltipTime = this.isMRMerged ? this.itemContent.mergedAt : this.itemContent.closedAt;
            return localeDateFormat.asDateTimeFull.format(newDate(tooltipTime));
        }
    },
    methods: {
        copyToClipboard (text, message) {
            toast(message);
            this.closeDropdown();
        },
        closeDropdown () {
            this.$refs.mrMoreActions.close();
        }
    }
};
